import React from "react";
import { useFormContext } from "react-hook-form";
import { Grid2 as Grid } from "@mui/material";
import { FormGroup } from "@cofano/cck";
import NumberInput from "components/cck/NumberInput";
import { Language } from "imports/Utils";
import { ShipSchemaInput, ShipSchemaOutput } from "view/ships/utils/ship.schema";

const ShipTonnageCertificatesForm = () => {

	const { setValue, watch } = useFormContext<ShipSchemaInput, unknown, ShipSchemaOutput>();

	const tonnageCertificates = watch("tonnageCertificates");

	return (
		<React.Fragment>
			<Grid container>
				<Grid size={6}>
					<h3>
						<FormGroup label={Language("SHIP_TONNAGE_CERTIFICATES_DEPTH")} labelPlacement="left-center" overflow="hidden">
							<span style={{ fontWeight: 500 }}>{Language("SHIP_TONNAGE_CERTIFICATES_TONNAGE")}</span>
						</FormGroup>
					</h3>

					{tonnageCertificates?.map(({ depth, tonnage }, index) => {
						return (
							<FormGroup
								label={depth}
								labelPlacement="left-center"
								overflow="hidden"
								key={depth}>
								<NumberInput
									value={tonnage}
									onChange={(value) => setValue(`tonnageCertificates.${index}.tonnage`, value)}
									decimalScale={0} />
							</FormGroup>
						);
					})}
				</Grid>
			</Grid>
		</React.Fragment>
	);
};

export default ShipTonnageCertificatesForm;
